export default __webpack_public_path__ + "static/media/nftcalendar_white.0d5a181a.png";